export const DRIVER_POLYLINE_COLOR = "#061A37";
export const DRIVER_POLYLINE_OPACITY = 0.46;
export const DRIVER_POLYLINE_WEIGHT = 7;
